import MarkdownIt from 'markdown-it';
import highlight from 'markdown-it-highlightjs';
import 'highlight.js/styles/default.css';


// 创建 MarkdownIt 实例
const md = new MarkdownIt({
  html: true,
  breaks: true,
  linkify: true,
});

function addAnchorLinks(md) {
  const originalHeadingOpen = md.renderer.rules.heading_open || function (tokens, idx, options, env, self) {
    return self.renderToken(tokens, idx, options);
  };

  md.renderer.rules.heading_open = function (tokens, idx, options, env, self) {
    // console.log('tokens is ', tokens)
    const token = tokens[idx];

    // 只处理 h2、h3、h4
    if (['h2', 'h3', 'h4'].includes(token.tag) && (idx - 1 < 0 || !['li'].includes(tokens[idx - 1].tag))) {

      // 获取标题文本
      const title = tokens[idx + 1].content;
      // 添加 id 属性
      token.attrSet('id', title);
    }

    return originalHeadingOpen(tokens, idx, options, env, self);
  };

  // 添加内部链接
  const originalHeadingClose = md.renderer.rules.heading_close || function (tokens, idx, options, env, self) {
    return self.renderToken(tokens, idx, options);
  };

  md.renderer.rules.heading_close = function (tokens, idx, options, env, self) {
    const token = tokens[idx];

    if (['h2', 'h3', 'h4'].includes(token.tag) && (idx - 3 < 0 || !['li'].includes(tokens[idx - 3].tag))) {
      // 获取标题文本
      const title = tokens[idx - 1].content;
      return ` <span class="header-anchor" style="display:none;" data-tag="${token.tag}" data-title="${title}"></span>${originalHeadingClose(tokens, idx, options, env, self)}`;

    }

    return originalHeadingClose(tokens, idx, options, env, self);
  };
}

md.use(addAnchorLinks);

// 使用 markdown-it-highlightjs 插件
md.use(highlight);


const parser = new DOMParser();




/**
 * 拆分组件文档md文件，方便分块显示调整样式
 * @param {string} content 组件文档的内容
 */
export async function splitCompMarkdown(content) {
  // 使用 ---$ 分割内容
  const parts = content.split('---$');

  // 验证分割后的部分数量
  if (parts.length !== 4) {
    throw new Error('请按照正确格式，用---$分割 README.md 文件');
  }

  // 渲染每个部分为HTML
  const htmlParts = [];
  // 组件名称部分
  htmlParts.push(md2html(parts[0].trim()));
  // 组件示例部分
  htmlParts.push(md2html(parts[1].trim()));
  // 组件API部分
  htmlParts.push(md2html(parts[2].trim()));

  // 兼容性 + 贡献者部分
  let customStr = `{{compatibility}} \n\t\n `;
  customStr += `\n\t\n ### 贡献者 \n\t\n   <div class="con-box"> \n\t\n ${parts[3].trim()} \n\t\n </div>`
  htmlParts.push(md2html(customStr));

  return htmlParts;
}


/**
 * 最终的 MD 转 HTML 函数
 * @param {string} mdstr
 * @returns {Promise<string>}
 */
/**
* @param {string} mdstr md的内容字符串
* @return {{html:string;titles:string[]}} str类型的html字符串
*/
export default function md2html(mdstr) {
  const htmlStr = md.render(mdstr);

  const doc = parser.parseFromString(htmlStr, 'text/html');
  const pres = doc.querySelectorAll('body>pre');
  pres.forEach((pre) => {
    const codedom = pre.querySelector('code');
    const code = codedom.textContent;
    const btn = document.createElement('button');
    btn.innerText = '复制';
    btn.setAttribute('content', code);
    btn.classList.add('code-copy-button');
    pre.innerHTML = '';
    const div = document.createElement('div');
    div.classList.add('code-body-box');
    div.appendChild(codedom);
    pre.appendChild(div);
    pre.appendChild(btn);
  });
  const tables = doc.querySelectorAll('table');
  tables.forEach((table) => {
    table.setAttribute('border', '1');
  });
  const titles = []
  const heads = doc.querySelectorAll('span.header-anchor');
  for (let i = 0; i < heads.length; i++) {
    const head = heads[i];
    const title = head.getAttribute('data-title');
    const tag = head.getAttribute('data-tag');
    titles.push({ title, tag });
  }
  // 返回转换后的html
  return { html: doc.body.innerHTML, titles };
}